var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplaz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43024 0.0669327C5.89936 0.0669327 4.65454 1.3202 4.65454 2.86148V5.65603H12.0577C13.5886 5.65603 14.8334 4.40276 14.8334 2.86148V0.0669327H7.43024ZM13.9082 2.86148C13.9082 3.889 13.0783 4.72451 12.0577 4.72451H5.57978V2.86148C5.57978 1.83396 6.40965 0.998448 7.43024 0.998448H13.9082V2.86148Z",
    fill: "url(#paint0_linear_1385_17892)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0664062 9.41093V12.2055C0.0664062 13.7468 1.31122 15 2.84211 15H14.8328V12.2055C14.8328 10.6642 13.588 9.41093 12.0571 9.41093H0.0664062V9.41093ZM0.991641 10.3424H12.0571C13.0777 10.3424 13.9076 11.178 13.9076 12.2055V14.0685H2.84211C1.82152 14.0685 0.991641 13.233 0.991641 12.2055V10.3424Z",
    fill: "url(#paint1_linear_1385_17892)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17892",
    x1: 0.989685,
    y1: 2.86148,
    x2: 12.2652,
    y2: 2.86148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1385_17892",
    x1: 0.642423,
    y1: 12.2055,
    x2: 13.2297,
    y2: 12.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplaz);
export default __webpack_public_path__ + "static/media/simplaz.a1dd95a4f8b304e8d7c7d5b761a1b14e.svg";
export { ForwardRef as ReactComponent };